import { FeatureCollection, Feature, GeometryCollection } from 'geojson'
import * as topojson from 'topojson-client'
import useSWR from 'swr'

// -----------------------------------------------------------------------------

export type GeodataFeature = 'lakes' | 'country' | 'cantons' | 'municipalities'

const dataUrls = [
  {
    year: 2018,
    features: {
      lakes: require('../../topojson/2018/ch-lakes.json'),
      country: require('../../topojson/2018/ch-country.json'),
      cantons: require('../../topojson/2018/ch-cantons.json'),
      municipalities: require('../../topojson/2018/ch-municipalities.json'),
    },
  },
  {
    year: 2019,
    features: {
      lakes: require('../../topojson/2019/ch-lakes.json'),
      country: require('../../topojson/2019/ch-country.json'),
      cantons: require('../../topojson/2019/ch-cantons.json'),
      municipalities: require('../../topojson/2019/ch-municipalities.json'),
    },
  },
  {
    year: 2020,
    features: {
      lakes: require('../../topojson/2020/ch-lakes.json'),
      country: require('../../topojson/2020/ch-country.json'),
      cantons: require('../../topojson/2020/ch-cantons.json'),
      municipalities: require('../../topojson/2020/ch-municipalities.json'),
    },
  },
  {
    year: 2021,
    features: {
      lakes: require('../../topojson/2021/ch-lakes.json'),
      country: require('../../topojson/2021/ch-country.json'),
      cantons: require('../../topojson/2021/ch-cantons.json'),
      municipalities: require('../../topojson/2021/ch-municipalities.json'),
    },
  },
  {
    year: 2022,
    features: {
      lakes: require('../../topojson/2022/ch-lakes.json'),
      country: require('../../topojson/2022/ch-country.json'),
      cantons: require('../../topojson/2022/ch-cantons.json'),
      municipalities: require('../../topojson/2022/ch-municipalities.json'),
    },
  },
  {
    year: 2023,
    features: {
      lakes: require('../../topojson/2023/ch-lakes.json'),
      country: require('../../topojson/2023/ch-country.json'),
      cantons: require('../../topojson/2023/ch-cantons.json'),
      municipalities: require('../../topojson/2023/ch-municipalities.json'),
    },
  },
  {
    year: 2024,
    features: {
      lakes: require('../../topojson/2024/ch-lakes.json'),
      country: require('../../topojson/2024/ch-country.json'),
      cantons: require('../../topojson/2024/ch-cantons.json'),
      municipalities: require('../../topojson/2024/ch-municipalities.json'),
    },
  },
  {
    year: 2025,
    features: {
      lakes: require('../../topojson/2025/ch-lakes.json'),
      country: require('../../topojson/2025/ch-country.json'),
      cantons: require('../../topojson/2025/ch-cantons.json'),
      municipalities: require('../../topojson/2025/ch-municipalities.json'),
    },
  },
]

function lookupUrl(year: number, feature: GeodataFeature): string {
  const entry = (() => {
    if (year < dataUrls[0].year) {
      return dataUrls[0]
    } else {
      return dataUrls.find((x) => x.year >= year) || dataUrls[dataUrls.length - 1]
    }
  })()

  return entry.features[feature]
}

// -----------------------------------------------------------------------------

export type BallotFeatureCollection = FeatureCollection<GeometryCollection, { parentId?: number }>

export type BallotFeature = Feature<GeometryCollection, { parentId?: number }>

// -----------------------------------------------------------------------------

export interface UseGeodataProps {
  feature: GeodataFeature
  year: number
}

async function fetcher(props: UseGeodataProps) {
  const { year, feature } = props

  const url = lookupUrl(year, feature)

  const res = await fetch(url)
  const json = await res.json()

  return topojson.feature(json, json.objects[feature]) as unknown as BallotFeatureCollection
}

export function useGeodata(props: UseGeodataProps) {
  return useSWR(props, fetcher)
}
